import { RequestFileDto } from "../Schemas/RequestFileDto";

/**
 * Resolves taxonomy id for grouping. Prefer scalar `taxonomyId` over nested `taxonomy.id` so that after
 * a category change we do not keep showing the old category when both were briefly inconsistent.
 */
export function getAttachmentFileTaxonomyId(file: RequestFileDto): number | null {
    if (file.taxonomyId !== undefined && file.taxonomyId !== null) {
        return file.taxonomyId;
    }
    if (file.taxonomyId === null) {
        return null;
    }
    const nested = file.taxonomy?.id;
    return nested == null ? null : nested;
}
